module.exports = __webpack_public_path__ + "static/accounts_azure-2c680b0ddd57bd45ab9fa2b8630ae4bc.png";